import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'


export default {
  namespaced: true,

  state () {
    return {
      challengeData: [],
      minScore: 0,
      maxScore: 0,
      visibilityScore: 0
    }
  },

  getters: {
   getHealthReportChallenge: state => state.challengeData,
   getMinScore: state => state.minScore,
   getMaxScore: state => state.maxScore,
   getVisibilityScore: state => state.visibilityScore 
  },

  mutations: {
    setHealthReportChallenge(state, challengeData) {
      state.challengeData = challengeData.challenges;
      localStorage.setItem('challengesData', JSON.stringify(challengeData.challenges))
    },
    setMinScore (state, minScore) {
      state.minScore = minScore
    },
    setMaxScore (state, maxScore) {
      state.maxScore = maxScore
    },
    setVisibilityScoreFromLocalStorage (state){
      const sessionFoundry = localStorage.getItem('sessionFoundryId');
      const userFoundries = JSON.parse(localStorage.getItem('userFoundries'));

     if (userFoundries && sessionFoundry) {
      userFoundries.forEach((element) => {
      if (element.id === sessionFoundry) {
        state.visibilityScore = element.visibilityScore
      }
    });
  }
    }
  },

  actions: {
    getFoundryHealthChallenges({ commit, state}, requestData) {
      return new Promise((resolve, reject) => {
        Api.FoundryHealth.getFoundryHealthChallenges(requestData.foundryId)
          .then(response => {
          commit('setHealthReportChallenge', response.data)
          commit('setMinScore', response.data.minScore)
          commit('setMaxScore', response.data.maxScore)
          commit('setVisibilityScoreFromLocalStorage')
          return resolve(response.data)
        })
        .catch((error) => {
          const err = Errors.create(error)
          reject(err)
        })
      })
    },
  },

  modules: {
    errors: VuexErrors
  }
}
